export enum DPIBreakpoints {
  BAD = 0,
  MEDIUM = 50,
  GOOD = 120,
  EXCELLENT = 150,
}
